export default (state,getters)=>({category})=>{
    return getters.list.filter(i => {
        if((category||category===0)&&i.category!==category)return false;
        return true;
    })
}